<template>
    <div v-if="pode_exibir && dados">
        <az-sub-title :title="familia ? 'Outros Participantes' : 'Outros pacientes no mesmo endereço'" class="mb-3"></az-sub-title>

        <div class="card" v-for="(outro, index) in dados.outros_pac" :key="index">
            <div class="card-header d-flex justify-content-between">
                <div>
                    Paciente: {{ index + 2 }}
                </div>
                <div>
                    <a href="#" @click.prevent="remover(index)">
                        <i class="fa fa-times" aria-hidden="true"></i>
                    </a>
                </div>
            </div>
            <div class="card-body">

                <div>
                    <div class="d-flex flex-column mb-3">
                        <az-input
                            type="button-group"
                            sizing="sm"
                            :optionsList="[
                                { id: 'P', search: 'Paciente' }, 
                                { id: '1', search: 'Primeira Vez' }, 
                            ]"
                            optionsData="id"
                            v-model="outro.tipo" />
                    </div>

                    <div v-if="outro.tipo == 'P'">
                        <az-input
                            placeholder="Informe o nome ou CPF do paciente..."
                            icon="fas fa-user"
                            type="autocomplete"
                            optionsMode="aql"
                            service="pacientes.index"
                            optionsDisplay="search"
                            :optionsParm="{ mrc: true }"
                            ref="info_paciente"
                            required
                            :validate="validate"
                            v-model="outro.paciente"
                            :optimized_ac="true">
                        </az-input>
                    </div>

                    <div v-else-if="outro.tipo == '1'">

                        <cadastro-temporario
                            v-model="outro.cadastro_temporario"
                            :validate="validate"
                            @selecionar="identificar_paciente" />

                    </div>

                    <div v-if="familia && complementos && complementos.length">
                        <az-input
                            placeholder="Relação..."
                            icon="fa-solid fa-family fa-fw"
                            type="select"
                            :optionsList="complementos.map(c => ({ id: c, search: c }))"
                            optionsData="id"
                            v-model="outro.complemento"
                            required
                            :validate="validate" />
                    </div>

                    <div> 
                        <az-input
                            placeholder="Operadora/Plano..."
                            icon="far fa-credit-card"
                            type="autocomplete"
                            optionsMode="aql"
                            optionsName="planos.atendimento"
                            :optionsParm="{
                                atendimento: true,
                                plano_id_unidade_operacao: id_unidade_operacao,  
                            }"
                            service="planos.index"
                            :optionsSync="false"
                            v-model="outro.plano"
                            required
                            :validate="validate"
                            ref="info_plano" />
                    </div>

                </div>

            </div>

        </div>

        <button type="button" class="btn btn-sm btn-outline-primary" @click="incluir()">
            <i class="fa fa-plus mr-2" aria-hidden="true"></i>
            Incluir
        </button>

        <!--
        <ul class="nav nav-tabs mt-3" id="myTab" role="tablist">
            <li class="nav-item" role="presentation" v-for="(outro, index) in dados.outros_pac" :key="index">
                <a class="nav-link" :class="index ? '' : 'active'" :id="'outro-pac-tab-' + index" data-toggle="tab" :href="'#outro-p-' + index" role="tab" aria-controls="home" aria-selected="true">
                    {{ index + 1 }}
                </a>
            </li>
            <li class="nav-item" role="presentation">
                <a href="#" class="nav-link" @click.prevent="incluir()">
                    Novo
                </a>
            </li>
        </ul>

        <div class="tab-content mb-3" id="myTabContent">
            <div class="tab-pane fade" :class="index ? '' : 'show active'" :id="'outro-p-' + index" role="tabpanel" aria-labelledby="home-tab" v-for="(outro, index) in dados.outros_pac" :key="index">

                <div class="mt-3">
                    <div class="d-flex flex-column mb-3">
                        <az-input
                            type="button-group"
                            sizing="sm"
                            :optionsList="[
                                { id: 'P', search: 'Paciente' }, 
                                { id: '1', search: 'Primeira Vez' }, 
                            ]"
                            optionsData="id"
                            v-model="outro.tipo" />
                    </div>

                    <div v-if="outro.tipo == 'P'" class="mb-3">
                        <az-input
                            placeholder="Informe o nome ou CPF do paciente..."
                            icon="fas fa-user"
                            type="autocomplete"
                            optionsMode="aql"
                            service="pacientes.index"
                            optionsDisplay="search"
                            :optionsParm="{ mrc: true }"
                            ref="info_paciente"
                            v-model="outro.paciente"
                            :optimized_ac="true">
                        </az-input>
                    </div>

                    <div v-else-if="outro.tipo == '1'" class="mb-3">

                        <cadastro-temporario
                            v-model="outro.cadastro_temporario"
                            :validate="validate"
                            @selecionar="identificar_paciente" />

                    </div>

                </div>

            </div>
        </div>
        -->

        <br><br><br>
    </div>
</template>

<script>
import CadastroTemporario from './CadastroTemporario.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubTitle from '../../util/AzSubTitle.vue';

export default {
    data() {
        return { 
            dados: { 
                outros_pac: [],
            }, 
            pode_exibir: false, 
        };
    },

    props: ['validate', 'plano', 'id_unidade_operacao', 'familia', 'complementos'], 

    components: { 
        AzInput, 
        AzSubTitle, 
        CadastroTemporario,
    },

    methods: { 
        iniciar () { 
            this.pode_exibir = false;

            this.$nextTick(() => { 
                this.dados.outros_pac = [];
                this.pode_exibir = true;
            });
        },

        remover (index) { 
            this.dados.outros_pac.splice(index, 1);
        },

        identificar_paciente (paciente) { 
            console.log(paciente);
        },

        incluir() { 
            this.dados.outros_pac.push({
                tipo: 'P',
                paciente: "", 
                cadastro_temporario: { 
                    st_nome: "", 
                },
                plano: this.plano, 
            });
        },

        obter_lista() { 
            return this.dados.outros_pac;
        }
    },

    mounted() { 
        this.iniciar();
    }
}
</script>
